// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RulesTab_wrapper__KUAvx .RulesTab_title__G9RAq {
  font-size: 32px;
  font-weight: 700;
  color: #FAF9F8;
}
.RulesTab_wrapper__KUAvx .RulesTab_subtitle__GiTMf {
  font-size: 20px;
  font-weight: 400;
  color: #C2BDB2;
  margin-top: 12px;
  margin-bottom: 25px;
}
.RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr .RulesTab_rulesItem__rikSa {
  background: #222121;
  border-radius: 12px;
  padding: 16px;
  width: 33%;
  min-height: 300px;
}
.RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr .RulesTab_rulesItem__rikSa .RulesTab_rulesItemImage__6DyXh {
  margin-bottom: 12px;
}
.RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr .RulesTab_rulesItem__rikSa .RulesTab_rulesItemTitle__ezL7y {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #FAF9F8;
}
.RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr .RulesTab_rulesItem__rikSa .RulesTab_rulesItemDescription__eLVHY {
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 16px;
  color: #C2BDB2;
}

@media (max-width: 1100px) {
  .RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr {
    display: block;
  }
  .RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr .RulesTab_rulesItem__rikSa {
    margin-bottom: 16px;
    width: 100%;
  }
  .RulesTab_wrapper__KUAvx .RulesTab_rules__jI5Jr .RulesTab_rulesItem__rikSa .RulesTab_rulesItemImage__6DyXh img {
    width: 100px;
  }
}
@media (max-width: 600px) {
  .RulesTab_wrapper__KUAvx .RulesTab_title__G9RAq {
    font-size: 28px;
  }
  .RulesTab_wrapper__KUAvx .RulesTab_subtitle__GiTMf {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Cybermarathon/components/RulesTab/RulesTab.module.scss"],"names":[],"mappings":"AAEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAHJ;AAKI;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;AAHN;AAKM;EACE,mBAAA;AAHR;AAMM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAJR;AAOM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALR;;AAWA;EAMI;IACE,cAAA;EAbJ;EAeI;IACE,mBAAA;IACA,WAAA;EAbN;EAgBQ;IACE,YAAA;EAdV;AACF;AAyBA;EAEI;IACE,eAAA;EAxBJ;EA2BE;IACE,eAAA;EAzBJ;AACF","sourcesContent":[".wrapper {\n\n  .title {\n    font-size: 32px;\n    font-weight: 700;\n    color: #FAF9F8;\n  }\n\n  .subtitle {\n    font-size: 20px;\n    font-weight: 400;\n    color: #C2BDB2;\n    margin-top: 12px;\n    margin-bottom: 25px;\n  }\n\n  .rules {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n\n    .rulesItem {\n      background: #222121;\n      border-radius: 12px;\n      padding: 16px;\n      width: 33%;\n      min-height: 300px;\n\n      .rulesItemImage {\n        margin-bottom: 12px;\n      }\n\n      .rulesItemTitle {\n        margin-bottom: 8px;\n        font-size: 16px;\n        font-weight: 600;\n        color: #FAF9F8;\n      }\n\n      .rulesItemDescription {\n        margin-bottom: 8px;\n        font-weight: 400;\n        font-size: 16px;\n        color: #C2BDB2;\n      }\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .wrapper {\n    .title {}\n\n    .subtitle {}\n\n    .rules {\n      display: block;\n\n      .rulesItem {\n        margin-bottom: 16px;\n        width: 100%;\n\n        .rulesItemImage {\n          img {\n            width: 100px;\n          }\n        }\n\n        .rulesItemTitle {}\n\n        .rulesItemDescription {}\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .wrapper {\n    .title {\n      font-size: 28px;\n    }\n\n    .subtitle {\n      font-size: 18px;\n    }\n\n    .rules {\n\n      .rulesItem {\n      \n\n        .rulesItemImage {}\n\n        .rulesItemTitle {}\n\n        .rulesItemDescription {}\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `RulesTab_wrapper__KUAvx`,
	"title": `RulesTab_title__G9RAq`,
	"subtitle": `RulesTab_subtitle__GiTMf`,
	"rules": `RulesTab_rules__jI5Jr`,
	"rulesItem": `RulesTab_rulesItem__rikSa`,
	"rulesItemImage": `RulesTab_rulesItemImage__6DyXh`,
	"rulesItemTitle": `RulesTab_rulesItemTitle__ezL7y`,
	"rulesItemDescription": `RulesTab_rulesItemDescription__eLVHY`
};
export default ___CSS_LOADER_EXPORT___;
